"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const react_1 = require("react");

const dataReaderInitializer_1 = require("./dataReaderInitializer");

function useAsyncResource(apiFunction) {
  for (var _len = arguments.length, parameters = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    parameters[_key - 1] = arguments[_key];
  }

  const dataReaderObj = react_1.useRef(() => undefined);
  react_1.useMemo(() => {
    if (parameters.length) {
      if (!apiFunction.length && parameters.length === 1 && Array.isArray(parameters[0]) && parameters[0].length === 0) {
        dataReaderObj.current = dataReaderInitializer_1.initializeDataReader(apiFunction);
      } else {
        dataReaderObj.current = dataReaderInitializer_1.initializeDataReader(apiFunction, ...parameters);
      }
    }
  }, [apiFunction, ...parameters]);
  const [, forceRender] = react_1.useState(0);
  const updaterFn = react_1.useCallback(function () {
    for (var _len2 = arguments.length, newParameters = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      newParameters[_key2] = arguments[_key2];
    }

    dataReaderObj.current = dataReaderInitializer_1.initializeDataReader(apiFunction, ...newParameters);
    forceRender(ct => 1 - ct);
  }, [apiFunction]);
  return [dataReaderObj.current, updaterFn];
}

exports.useAsyncResource = useAsyncResource;